/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type contacts_UpdateContactStatusRequest = {
    status: contacts_UpdateContactStatusRequest.status;
};
export namespace contacts_UpdateContactStatusRequest {
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        UPCOMING = 'UPCOMING',
    }
}

